import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import TabsSearchTermHandler from "@sunSource/Store/Data/TabsData/Handler/TabsSearchTermHandler";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import CustomApplicationState from "@sunSource/Store/CustomApplicationState";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

export interface NewsListTagStyle {
    activeTagItem?: InjectableCss;
    tagItem?: InjectableCss;
    tagsWrapper?: InjectableCss;
}

interface OwnProps {
    tags: string;
    extendedStyles?: NewsListTagStyle;
    isonClickActiontoPerform?: boolean;
}

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => ({
    tagsName: state.sunSourceState.TabsActiveData.tagsName,
});

const mapDispatchToProps = {
    TabsSearchTermHandler,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export const newsListTagtyle: NewsListTagStyle = {
    activeTagItem: {
        css: css`
            display: inline-flex;
            align-items: center;
            padding: 6px 12px;
            border-radius: 4px;
            background-color: ${getColor("primary")};
            color: ${getColor("primary.contrast")};
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.5px;
            white-space: nowrap;
            cursor: pointer;
            text-transform: capitalize;
            &:hover {
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            }
        `,
    },
    tagItem: {
        css: css`
            display: inline-flex;
            align-items: center;
            padding: 6px 12px;
            border-radius: 4px;
            background-color: #f1f1f1;
            color: #756e6e;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.5px;
            white-space: nowrap;
            cursor: pointer;
            text-transform: capitalize;
            &:hover {
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            }
        `,
    },
    tagsWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-top: 30px;
        `,
    },
};


const NewsListTag = ({ tags, tagsName, extendedStyles, isonClickActiontoPerform = false, TabsSearchTermHandler, history }: Props) => {
    const [styles] = React.useState(() => mergeToNew(newsListTagtyle, extendedStyles));

    const onClickTags = (tag: string) => {
        if(!isonClickActiontoPerform){
            return;
        }
        const normalizedTag = tag.trim().toLowerCase();
        // If tag already exists, do nothing
        if (tagsName && tagsName.includes(normalizedTag)) {
            return;
        }

        const url = new URL(window.location.href);

        const currentTags =
            url.searchParams
                .get("tag")
                ?.split(",")
                .map(t => t.trim().toLowerCase()) || [];

        currentTags.push(normalizedTag);

        url.searchParams.set("tag", currentTags.join(","));
        url.searchParams.set("page", "1");

         history.replace(url.pathname + url.search);

        TabsSearchTermHandler({ tagsName: normalizedTag });
    };
    return (
        <StyledWrapper {...styles.tagsWrapper}>
            {tags.split(",").map((tag: string, index: number) => {
                const normalizedTag = tag.trim().toLowerCase();

                const tagStyles =
                    tagsName && tagsName.includes(normalizedTag) ? { ...styles.activeTagItem } : { ...styles.tagItem };
                return (
                    <StyledWrapper key={`${tag}_${index}`} {...tagStyles} onClick={() => onClickTags(tag)}   style={{ cursor: isonClickActiontoPerform ? "pointer" : "default" }}>
                        {tag.trim()}
                    </StyledWrapper>
                );
            })}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(NewsListTag));
